import { render, staticRenderFns } from "./WrongTitle.vue?vue&type=template&id=3aafcbfa&scoped=true"
import script from "./WrongTitle.vue?vue&type=script&lang=js"
export * from "./WrongTitle.vue?vue&type=script&lang=js"
import style0 from "./WrongTitle.vue?vue&type=style&index=0&id=3aafcbfa&prod&lang=scss&scoped=true"
import style1 from "./WrongTitle.vue?vue&type=style&index=1&id=3aafcbfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aafcbfa",
  null
  
)

export default component.exports